// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");
var Highcharts$ReactHooksTemplate = require("../../common/Highcharts.res.js");

function RadialBarChartComponent(props) {
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(Highcharts$ReactHooksTemplate.HighchartsGaugeBinding.make, {}),
              className: props.chartHeight
            });
}

var make = RadialBarChartComponent;

exports.make = make;
/* react/jsx-runtime Not a pure module */
